import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ajaj2rm3ar: FaireBrandEntity = {
  token: "b_ajaj2rm3ar",
  type: "brand",
  name: "Store Supply Warehouse",
  avatarUrl: "https://cdn.faire.com/fastly/696fa1ef8a20a1ac361bfa2affb7dd27b5d3da88b2069daa77cdaae209f8c3d9.jpeg",
  bannerUrl: "https://cdn.faire.com/fastly/61591046b4f05865854f709e120960d43e5af70a62ad2088e1dbce1e6f6c9f85.jpeg",
  logoUrl: "https://cdn.faire.com/fastly/696fa1ef8a20a1ac361bfa2affb7dd27b5d3da88b2069daa77cdaae209f8c3d9.jpeg",
  heroImageUrl: "https://cdn.faire.com/fastly/61591046b4f05865854f709e120960d43e5af70a62ad2088e1dbce1e6f6c9f85.jpeg",
  location: "Bridgeton, MO, USA",
  minimumOrderDollars: 99,
  rating: 4.9,
  reviewCount: 802,
  isTopShop: true,
  isInsider: true,
  description: "Store Supply Warehouse has been serving the retail and small business industries for over 30 years. We provide the very best in store fixtures and supplies for small businesses, online retailers, boutiques and more. Whether you are looking for a full line of retail bags and packaging, clothing racks, hangers, jewelry supplies, display cases and more, Store Supply Warehouse is always open to get you what you need to start or maintain your business. \n\nThe Store Supply Warehouse philosophy is very simple. “Take care of the customer every time without hesitation.” We are devoted to delivering complete customer satisfaction by way of respect, knowledge and teamwork. We offer the lowest prices guaranteed anywhere, and with our super fast shipping, we are able to get you what your business needs when you need it.  Let Store Supply Warehouse help you build the store of your dreams!",
  meta: {
    source: "api",
    importedAt: "2026-10-28T20:56:45.954Z",
    importedBy: "entity-db-cli"
  }
};
